
<h1 mat-dialog-title>Alert {{teamName}} OnCall Member</h1>
<div mat-dialog-content>
  <form [formGroup]="commentFormGroup">
    <mat-form-field class="input">
      <mat-label style="font-weight: bold;">Comment</mat-label>
      <input matInput formControlName="comment" id="textBox" type="text">
      @if (commentFormGroup.get('comment')!.hasError('required')) {
        <mat-error>Comment Is Required.</mat-error>
      }
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="closePopup(false)">Cancel</button>
  <button mat-raised-button [disabled]="!commentFormGroup.valid" (click)="sendAlert(commentInput)" style="color: white; background-color: red;">Send Alert</button>
</div>
